export default __webpack_public_path__ + "static/Outfit-Bold-cf636bfe647fbba1b7e8d74399bdec45.woff2";